"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeacherPinSchema = exports.PollTeacherPinSchema = exports.MapTeacherPinSchema = exports.LinkTeacherPinSchema = exports.VideoTeacherPinSchema = exports.DragQuestionTeacherPinSchema = exports.WordCloudTeacherPinSchema = exports.OpenQuestionTeacherPinSchema = exports.SlideTeacherPinSchema = exports.QuizTeacherPinSchema = void 0;
const zod_1 = require("zod");
const quiz_pin_1 = require("./quiz-pin");
const slide_pin_1 = require("./slide-pin");
const placeholder_pins_1 = require("./placeholder-pins");
const video_pin_1 = require("./video-pin");
const word_cloud_pin_1 = require("./word-cloud-pin");
const open_question_pin_1 = require("./open-question-pin");
const base_teacher_pin_1 = require("./base-teacher-pin");
exports.QuizTeacherPinSchema = quiz_pin_1.QuizPinSchema.merge(zod_1.z.object({
    teacherSettings: quiz_pin_1.QuizTeacherPinSettingsSchema,
}));
exports.SlideTeacherPinSchema = slide_pin_1.SlidePinSchema.merge(zod_1.z.object({
    teacherSettings: slide_pin_1.SlideTeacherPinSettingsSchema,
}));
// TODO: Add specific teacherSettings for each placeholder
exports.OpenQuestionTeacherPinSchema = open_question_pin_1.OpenQuestionPinSchema.merge(zod_1.z.object({
    teacherSettings: open_question_pin_1.OpenQuestionTeacherPinSettingsSchema,
}));
exports.WordCloudTeacherPinSchema = word_cloud_pin_1.WordCloudPinSchema.merge(zod_1.z.object({
    teacherSettings: base_teacher_pin_1.BaseTeacherPinSettingsSchema.merge(zod_1.z.object({})),
}));
exports.DragQuestionTeacherPinSchema = placeholder_pins_1.DragQuestionPinSchema.merge(zod_1.z.object({
    teacherSettings: base_teacher_pin_1.BaseTeacherPinSettingsSchema.merge(zod_1.z.object({})),
}));
exports.VideoTeacherPinSchema = video_pin_1.VideoPinSchema.merge(zod_1.z.object({
    teacherSettings: base_teacher_pin_1.BaseTeacherPinSettingsSchema.merge(zod_1.z.object({})),
}));
exports.LinkTeacherPinSchema = placeholder_pins_1.LinkPinSchema.merge(zod_1.z.object({
    teacherSettings: base_teacher_pin_1.BaseTeacherPinSettingsSchema.merge(zod_1.z.object({})),
}));
exports.MapTeacherPinSchema = placeholder_pins_1.MapPinSchema.merge(zod_1.z.object({
    teacherSettings: base_teacher_pin_1.BaseTeacherPinSettingsSchema.merge(zod_1.z.object({})),
}));
exports.PollTeacherPinSchema = placeholder_pins_1.PollPinSchema.merge(zod_1.z.object({
    teacherSettings: base_teacher_pin_1.BaseTeacherPinSettingsSchema.merge(zod_1.z.object({})),
}));
exports.TeacherPinSchema = zod_1.z.discriminatedUnion('type', [
    exports.QuizTeacherPinSchema,
    exports.SlideTeacherPinSchema,
    exports.OpenQuestionTeacherPinSchema,
    exports.WordCloudTeacherPinSchema,
    exports.DragQuestionTeacherPinSchema,
    exports.VideoTeacherPinSchema,
    exports.LinkTeacherPinSchema,
    exports.MapTeacherPinSchema,
    exports.PollTeacherPinSchema,
]);
// If this gives you an error, update the TeacherPinSchema union
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ensureTypesAreInSync = true;
//# sourceMappingURL=teacher.pin.js.map